import { HStack, Text } from '@chakra-ui/react';
import React from 'react';


function getElapsedSecondsSince(startDate: Nullable<Date>): number {
	const now = new Date();
	const date = (startDate ?? now);
	const difference = now.getTime() - date.getTime();
	return difference <= 0 ? 0 : Math.floor(difference / 1000);
}

function formatTime(totalSeconds: number): { hours: string, minutes: string, seconds: string } {
	const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
	const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
	const seconds = (totalSeconds % 60).toString().padStart(2, '0');
	return { hours, minutes, seconds };
};

export const Timer = ({ startDate }: { startDate: Nullable<Date> }) => {

	const [elapsed, setElapsed] = React.useState<number>(getElapsedSecondsSince(startDate));

	React.useEffect(() => {
		const interval = setInterval(() => setElapsed(getElapsedSecondsSince(startDate)), 1000);
		return () => clearInterval(interval);
	}, [startDate]);


	const { hours, minutes, seconds } = formatTime(elapsed);

	const color = startDate === null ? { base: '{colors.neutral.300}', _dark: '{colors.neutral.300}' } : { base: '{colors.neutral.800}', _dark: 'white' };
	return <HStack justifyContent={'center'}>
		<HStack bg={{ base: 'white', _dark: '{colors.neutral.800}' }} border={{ base: 'none', _dark: '1px solid {colors.neutral.500}' }} borderRadius={'md'} width={'14'} height={'12'} color={color} justifyContent={'center'}>
			<Text fontWeight={'bold'} fontSize={'lg'} justifyContent={'center'}>{hours}</Text>
		</HStack>
		<HStack fontWeight={'bold'} fontSize={'lg'} color={color} justifyContent={'center'}>:</HStack>
		<HStack bg={{ base: 'white', _dark: '{colors.neutral.800}' }} border={{ base: 'none', _dark: '1px solid {colors.neutral.500}' }} borderRadius={'md'} width={'14'} height={'12'} color={color} justifyContent={'center'}>
			<Text fontWeight={'bold'} fontSize={'lg'}>{minutes}</Text>
		</HStack>
		<HStack fontWeight={'bold'} fontSize={'lg'} color={color} justifyContent={'center'}>:</HStack>
		<HStack bg={{ base: 'white', _dark: '{colors.neutral.800}' }} border={{ base: 'none', _dark: '1px solid {colors.neutral.500}' }} borderRadius={'md'} width={'14'} height={'12'} color={color} justifyContent={'center'}>
			<Text fontWeight={'bold'} fontSize={'lg'}>{seconds}</Text>
		</HStack>
	</HStack>;
};